// types
import type { FieldProps } from './field';

// styles
import styles from './form.module.scss';

// utils
import { classNameBuilder } from 'utils/classNameBuilder';

export function getPreviewId(formType: string, index?: number) {
  return formType === 'leadmodule' || index === undefined ? undefined : `#${index}`;
}

export function getClassName({
  isGroup,
  fieldSize,
  hasValidPrecondition,
  hasOxomitButtonWrapper,
  isFileUpload,
  isNord,
  reduceBottomDistanceToNextElement,
}) {
  return classNameBuilder(
    isGroup ? styles.gddsField : `cell medium-${fieldSize}`,
    fieldSize === 6 ? 'half' : 'full',
    hasValidPrecondition,
    hasOxomitButtonWrapper,
    isFileUpload && 'fileUpload',
    isNord && reduceBottomDistanceToNextElement && 'consent-form-checkbox',
  );
}

export function addDropdownDefaultOption(
  formFields: FieldProps[],
  optionLabel: string,
): FieldProps[] {
  return formFields.map((field) => {
    if (field.type === 'dropdown' && Boolean(field.addPlaceholder)) {
      return {
        ...field,
        options: [{ title: optionLabel, value: '' }, ...field.options],
      };
    }
    return field;
  });
}
